module.exports = __webpack_public_path__ + "img/Frame 18.b1aa4239.jpg";